import { useEffect } from "react";

function upsertMeta(name, content) {
  let metaTag = document.querySelector(`meta[name="${name}"]`);
  if (!metaTag) {
    metaTag = document.createElement("meta");
    metaTag.setAttribute("name", name);
    document.head.appendChild(metaTag);
  }
  metaTag.setAttribute("content", content);
}

function upsertCanonical(url) {
  let canonicalLink = document.querySelector('link[rel="canonical"]');
  if (!canonicalLink) {
    canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    document.head.appendChild(canonicalLink);
  }
  canonicalLink.setAttribute("href", url);
}

export default function PageSEO({ title, description, canonicalPath = "/" }) {
  useEffect(() => {
    document.title = title;
    upsertMeta("description", description);
    upsertCanonical(`${window.location.origin}${canonicalPath}`);
  }, [title, description, canonicalPath]);

  return null;
}
